import { defineStore } from 'pinia'
import { AbstractCongress } from '../../../../lib/index'
import { StoreHelper } from '../../helpers/storeHelper'

export const useAbstractStore = defineStore('abstract', {
  state: () => ({
    abstracts: [] as any[],
    total: 0,
  }),
  actions: {
    async findAllAbstracts({ query, url }: { query?: any, url?: string } = {}) {
      // We pass 'endpointAbstract' as the endpoint key. 
      // StoreHelper.loadRootState handles fetching from usePluginOptionsStore.
      const helper = StoreHelper.loadRootState('endpointAbstract')
      if (!url) {
        url = helper.url
      }

      const { findAll } = helper
      let arr = await findAll({ url }, query)

      if (Array.isArray(arr.data)) { // for new Qsystem api response
        arr = arr.data
      }

      if (Array.isArray(arr) && arr.length > 0) {
        const abstracts = AbstractCongress.initOnlyValidFromArray(arr || [])

        this.abstracts = abstracts
        this.total = abstracts.length || 0

        return {
          abstracts,
          total: abstracts.length || 0
        }
      }
      throw StoreHelper.error(arr, 'No abstract found.')
    }
  }
})

// Export default object for backward compatibility if needed, 
// but Pinia stores are usually used via the hook.
export default useAbstractStore
